
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Comment l’app «SwissCovid» aide à contrôler l’épidémie`}</h1>
    <h2>{`Comment isoler les personnes infectées assez tôt? L'app de la Confédération disponible depuis le 25 juin doit permettre de briser les chaîne d'infection du nouveau coronavirus. Notre explication interactive.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;